import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Parallax
{
  constructor(view)
  {
    this.view = view
  }

  animate()
  {
    const $element = this.view.querySelector('.jsParallax--receptor')
    const dataX = $element.getAttribute('data-x')
    gsap.to($element , { x : dataX , scrollTrigger: {
        immediateRender:false,
        start: ()=> this.view.offsetLeft,
        end: ()=>this.view.offsetLeft + window.innerWidth * 1.5,
        markers: false,
        scrub: Env.scrollTrigger.parallax.scrub,
      }
    })
  }
}
